import React, { useState } from "react"
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap"
import { useResponse } from "../../../../hooks/useResponse"
import { sendEmail } from "../../../../api/invoices"
import ReactSelect from "react-select"
import { languageTempletsOptions } from "../../../../utils/langTemplets"

const SendEmailModal = ({handleClose, isOpen, invoice}) => {
  const [msg, setMsg] = useState(null)
  const [template, setTemplate] = useState(null)

  const {loading, error, setData} = useResponse(sendEmail, () => {
    handleClose()
    setMsg("")
    setTemplate(null)
  })

  function handleSendEmail(){
    const data = {msg: msg || null, invoiceId: invoice?.id, templateKey: template?.value || null}
    setData({type: "add", data})
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
          <h2 className="text-center mb-4">Send Via Email</h2>
        
          <Row>
            <Col md={12}>
              <FormGroup className="">
                  <Label>Message:</Label>
                  <Input type="text" placeholder="write a message" value={msg} onChange={(e) => setMsg(e.target.value)} />
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup className="">
                  <Label>Template:</Label>
                  <ReactSelect
                    options={languageTempletsOptions}
                    value={template}
                    onChange={(op) => setTemplate(op)}
                    isSearchable={false}
                    isClearable={true}
                  />
              </FormGroup>
            </Col>
          </Row>

          <div className="mt-4 d-flex gap-4 align-items-center justify-content-center">
            <Button
              onClick={handleSendEmail}
              color="primary"
              size="lg"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send"}
            </Button>
            <Button onClick={handleClose} color="dark" size="lg">
              Cancel
            </Button>
          </div>
      </ModalBody>
    </Modal>
  )
}

export default SendEmailModal
